import { createComponent } from '@mtfe/sweet';
import Dialog, { hideDialog } from '../common/Dialog/script';

import tpl from './dom.html';
import style from './style.less';

const hideRulesPopup = () => {
    hideDialog();
};

const RulesPopup = (props = {}) => {
    const { content = '' } = props;

    const data = {
        content,
    };
    const contentComponent = createComponent(tpl, { data, style });

    Dialog({
        contentComponent,
    });
};

export default RulesPopup;

export { hideRulesPopup };
